import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Onboarding from "@/pages/Onboarding";
import OnboardingWizard from "@/pages/OnboardingWizard";
import WorkspaceOverview from "@/pages/WorkspaceOverview";
import ContextBrain from "@/pages/ContextBrain";
import Feed from "@/pages/Feed";
import Contacts from "@/pages/Contacts";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Posts from "@/pages/Posts";
import Outreach from "@/pages/Outreach";
import Owlbert from "@/pages/Owlbert";
import Compose from "@/pages/Compose";
import Brain from "@/pages/Brain";
import OwlbertChat from "@/pages/OwlbertChat";
import ClientPortal from "@/pages/ClientPortal";

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously during render (not in useEffect) to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <OnboardingWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding-classic"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/setup"
        element={
          <ProtectedRoute>
            <OnboardingWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId"
        element={
          <ProtectedRoute>
            <OwlbertChat scope="workspace" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/overview-classic"
        element={
          <ProtectedRoute>
            <WorkspaceOverview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/chat"
        element={
          <ProtectedRoute>
            <OwlbertChat scope="operator" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client/:workspaceId"
        element={
          <ProtectedRoute>
            <ClientPortal mode="auth" />
          </ProtectedRoute>
        }
      />
      <Route path="/p/:token" element={<ClientPortal mode="public" />} />
      <Route
        path="/workspace/:workspaceId/feed"
        element={
          <ProtectedRoute>
            <Feed />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/reports"
        element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/posts"
        element={
          <ProtectedRoute>
            <Posts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/outreach"
        element={
          <ProtectedRoute>
            <Outreach />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/owlbert"
        element={
          <ProtectedRoute>
            <OwlbertChat scope="workspace" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/compose"
        element={
          <ProtectedRoute>
            <OwlbertChat scope="workspace" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/brain"
        element={
          <ProtectedRoute>
            <Brain />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/contacts"
        element={
          <ProtectedRoute>
            <Contacts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/context-brain"
        element={
          <ProtectedRoute>
            <ContextBrain />
          </ProtectedRoute>
        }
      />
      <Route
        path="/workspace/:workspaceId/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
